// Models
import { createBranchStoreDefaultModel } from './branch/branch.store'
import { createCompanyStoreDefaultModel } from './company/company.store'
import { createDocumentDetailStoreDefaultModel } from './document-detail/document-detail.store'
import { createDocumentProofStoreDefaultModel } from './document-proof/document-proof.store'
import { createRoleStoreDefaultModel } from './role/role.store'
import { createFieldStoreDefaultModel } from './field/field.store'
import { createCertificationSchemaStoreDefaultModel } from './certification-schema/certification-schema.store'

const masterModels = {
  masterCompany: createCompanyStoreDefaultModel(),
  masterBranch: createBranchStoreDefaultModel(),
  masterDocumentDetail: createDocumentDetailStoreDefaultModel(),
  masterDocumentProof: createDocumentProofStoreDefaultModel(),
  masterRole: createRoleStoreDefaultModel(),
  masterField: createFieldStoreDefaultModel(),
  masterCertificationSchema: createCertificationSchemaStoreDefaultModel(),
}

export { masterModels }
